module.exports = __webpack_public_path__ + "static/img/RhythmPlanetLOGO.cca8ab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/RhythmPlanet/RhythmPlanetLOGO.png
// module id = ur7Y
// module chunks = 0